"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[411],{

/***/ 43354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cv": function() { return /* binding */ ErrorModal; },
/* harmony export */   "VF": function() { return /* binding */ AlertModal; }
/* harmony export */ });
/* unused harmony export ModalDialogContentText */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26993);
/* harmony import */ var _mui_material_Dialog__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1890);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68346);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13264);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60031);
/*
 * File: Modal.tsx
 * Project: @inventures/react-lib
 * File Created: Wednesday, 23rd September 2020 4:10:47 pm
 * Author: Esperanza Horn (esperanza@inventures.cl)
 * -----
 * Last Modified: Wednesday, 12th July 2023 6:57:54 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2020 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 










var IconContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div")({
    position: "relative",
    height: "14px",
    width: "14px",
    marginLeft: "90%",
    marginTop: "20px"
});
var Container = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div")({});
var DialogTitle = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "17px",
    lineHeight: "150%",
    letterSpacing: "0.15px",
    color: "#414046",
    textAlign: "center",
    marginBottom: "12px"
});
var DialogContentText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "150%",
    letterSpacing: "-0.011em",
    textAlign: "center",
    color: "#414046",
    margin: "0px 18px 12px 18px"
});
var DialogActions = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "direction";
    }
})(function(param) {
    var direction = param.direction;
    return {
        display: "flex",
        flexDirection: direction || "column",
        alignItems: "center",
        padding: direction === "row" ? "16px" : "17px 0px",
        gap: direction === "row" ? "16px" : "0px"
    };
});
var ButtonAction = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    borderRadius: "100px",
    height: "42px",
    width: "199px",
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    textDecoration: "none",
    textTransform: "none"
});
var Pointer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div")({
    cursor: "pointer"
});
var ModalDialog = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material_Dialog__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "changeDialogPaper";
    }
})(function(param) {
    var changeDialogPaper = param.changeDialogPaper;
    return {
        "& .MuiDialog-paper": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            margin: 16,
            maxWidth: 336
        }, changeDialogPaper ? {
            width: "100%",
            minHeight: 197
        } : {})
    };
});
var ModalDialogContentText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(DialogContentText, {
    shouldForwardProp: function(prop) {
        return prop !== "alingContentLeft";
    }
})(function(param) {
    var alignContentLeft = param.alignContentLeft;
    return {
        textAlign: alignContentLeft ? "left" : "center",
        whiteSpace: "pre-line"
    };
});
function AlertModal(props) {
    var title = props.title, open = props.open, content = props.content, children = props.children, actions = props.actions, actionsDirection = props.actionsDirection, setOpen = props.setOpen, onClose = props.onClose, disableEscapeKeyDown = props.disableEscapeKeyDown, onBackdropClick = props.onBackdropClick, AlignContentLeft = props.AlignContentLeft, changeDialogPaper = props.changeDialogPaper, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(props, [
        "title",
        "open",
        "content",
        "children",
        "actions",
        "actionsDirection",
        "setOpen",
        "onClose",
        "disableEscapeKeyDown",
        "onBackdropClick",
        "AlignContentLeft",
        "changeDialogPaper"
    ]);
    var handleClose = function() {
        if (onClose) onClose();
        else if (actions.length === 1) actions[0].onActionClick();
        setOpen(false);
    };
    var haveHandleClose = (actions === null || actions === void 0 ? void 0 : actions.length) === 1 || onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalDialog, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, otherProps), {
        open: open,
        onClose: handleClose,
        changeDialogPaper: changeDialogPaper,
        disableEscapeKeyDown: disableEscapeKeyDown,
        onBackdropClick: onBackdropClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconContainer, {
                    children: haveHandleClose && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Pointer, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            layout: "fill",
                            src: "/assets/images/home/closeicon.webp",
                            alt: "closeIcon",
                            objectFit: "contain",
                            onClick: handleClose
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DialogTitle, {
                    children: title
                }),
                content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalDialogContentText, {
                    alignContentLeft: AlignContentLeft,
                    children: content
                }),
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DialogActions, {
                    direction: actionsDirection,
                    children: actions === null || actions === void 0 ? void 0 : actions.map(function(action, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonAction, {
                            onClick: action.onActionClick,
                            color: "primary",
                            variant: action.variant,
                            children: action.text
                        }, index);
                    })
                })
            ]
        })
    }));
}
function ErrorModal(props) {
    var open = props.open, title = props.title, description = props.description, handleBack = props.handleBack, whatsappText = props.whatsappText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AlertModal, {
        title: title,
        open: open,
        setOpen: function() {},
        disableEscapeKeyDown: true,
        disableBackdropClick: true,
        actions: [
            {
                text: "Aceptar",
                onActionClick: handleBack,
                variant: "contained"
            }, 
        ],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ModalDialogContentText, {
            children: [
                description,
                ", intenta nuevamente o",
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    target: "_blank",
                    href: "https://api.whatsapp.com/send?phone=".concat(_config_environment__WEBPACK_IMPORTED_MODULE_3__/* .PHONE_NUMBER.CLEAN */ .UE.CLEAN, "&text=").concat(encodeURI(whatsappText)),
                    children: "cont\xe1ctanos para recibir ayuda"
                })
            ]
        })
    });
}


/***/ }),

/***/ 57758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ CategoriesSliderSkeleton; }
/* harmony export */ });
/* unused harmony export PillBoxDetailCardSkeleton */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79072);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91655);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29630);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13264);
/*
 * File: Skeletons.tsx
 * Project: meki
 * File Created: Tuesday, 21st December 2021 9:29:43 am
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Thursday, 16th November 2023 1:01:35 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 



var ContentDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div")({
    padding: "0px 10px 0px 10px",
    "@media (min-width: 900px)": {
        maxWidth: "1280px",
        margin: "auto"
    }
});
var SkeletonSliderDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div")({
    display: "flex",
    justifyContent: "space-evenly",
    "@media (min-width: 900px)": {
        width: "100%"
    },
    padding: "16px 0px 16px 0px"
});
var GridContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
    flexWrap: "nowrap",
    overflowY: "auto",
    width: "100%",
    "&::-webkit-scrollbar": {
        display: "none"
    },
    msOverflowStyle: "none" /* IE and Edge */ ,
    scrollbarWidth: "none" /* Firefox */ ,
    "@media (min-width: 800px)": {
        justifyContent: "space-around"
    }
});
var SliderItemGrid = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
    justifyContent: "center",
    minWidth: "111px",
    height: "auto !important",
    cursor: "pointer",
    marginRight: 6,
    "@media (min-width: 900px)": {
        width: 203,
        marginRight: 0
    },
    "@media (min-width: 500px)": {
        width: 150
    },
    "&:last-child": {
        marginRight: 0
    }
});
var SliderCircleIconSkeleton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    margin: "auto",
    height: 64,
    width: 64,
    "@media (min-width: 1000px)": {
        height: 130,
        width: 130
    },
    "@media (min-width: 600px)": {
        height: 80,
        width: 80
    },
    display: "flex",
    justifyContent: "center"
});
var CenterSkeleton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    marginLeft: "auto",
    marginRight: "auto"
});
var PillBoxDetailCardDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div")({
    display: "flex",
    margin: 16,
    height: 94
});
var PillBoxDetailImgDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div")({
    alignSelf: "center",
    marginRight: 16
});
var PillBoxDetailInfo = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div")({
    alignSelf: "center",
    width: "100%"
});
var PillBoxDetailNameSkeleton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    width: "calc(100% - 20%)"
});
var PillBoxDetailConcentrationSkeleton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    width: "calc(100% - 45%)"
});
var PillBoxDetailDateSkeleton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    width: "calc(100% - 60%)"
});
var PillBoxDetailCartInfoSkeleton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    width: "calc(100% - 60%)"
});
var PillBoxDetailActionButtonDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div")({
    alignSelf: "center"
});
function CategoriesSliderSkeleton() {
    var emptyArray = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(// eslint-disable-next-line @typescript-eslint/no-unsafe-return
    function() {
        return Array.from({
            length: 5
        }).map(function() {
            return null;
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentDiv, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonSliderDiv, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GridContainer, {
                container: true,
                spacing: 1,
                children: emptyArray.map(function(_x, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SliderItemGrid, {
                        item: true,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SliderCircleIconSkeleton, {
                                variant: "circular"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                variant: "h6",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CenterSkeleton, {
                                    variant: "text",
                                    width: "auto",
                                    height: 50
                                })
                            })
                        ]
                    }, i);
                })
            })
        })
    });
}
function PillBoxDetailCardSkeleton() {
    return /*#__PURE__*/ _jsxs(PillBoxDetailCardDiv, {
        children: [
            /*#__PURE__*/ _jsx(PillBoxDetailImgDiv, {
                children: /*#__PURE__*/ _jsx(CenterSkeleton, {
                    variant: "rectangular",
                    width: 62,
                    height: 62
                })
            }),
            /*#__PURE__*/ _jsxs(PillBoxDetailInfo, {
                children: [
                    /*#__PURE__*/ _jsx(PillBoxDetailNameSkeleton, {
                        variant: "text",
                        height: 20
                    }),
                    /*#__PURE__*/ _jsx(PillBoxDetailConcentrationSkeleton, {
                        variant: "text",
                        height: 20
                    }),
                    /*#__PURE__*/ _jsx(PillBoxDetailDateSkeleton, {
                        variant: "text",
                        height: 20
                    }),
                    /*#__PURE__*/ _jsx(PillBoxDetailCartInfoSkeleton, {
                        variant: "text",
                        height: 20
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(PillBoxDetailActionButtonDiv, {
                children: /*#__PURE__*/ _jsx(CenterSkeleton, {
                    variant: "circular",
                    width: 50,
                    height: 50
                })
            })
        ]
    });
}


/***/ }),

/***/ 23576:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var categories = [
    {
        name: "Medicamentos",
        slug: "medicamentos"
    },
    {
        name: "Belleza",
        slug: "belleza"
    },
    {
        name: "Accesorios y dispositivos",
        slug: "accesorios-y-dispositivos"
    },
    {
        name: "Cuidado personal",
        slug: "cuidado-personal"
    },
    {
        name: "Nutrici\xf3n y vitaminas",
        slug: "nutricion"
    }, 
];
/* harmony default export */ __webpack_exports__["Z"] = (categories);


/***/ }),

/***/ 78459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ AssistantButton; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Fab/Fab.js + 1 modules
var Fab = __webpack_require__(10160);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Add.js
var Add = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(68921);
;// CONCATENATED MODULE: ./src/queries/order/mutations/createOrder.tsx
/*
 * File: createOrder.tsx
 * Project: meki
 * File Created: Wednesday, 4th November 2020 11:08:37 am
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Thursday, 29th April 2021 12:46:47 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ",
        " {\n    createOrder {\n      id\n      uuid\n      orderDetails {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CreateOrderMutation = function(name) {
    return (0,lib/* gql */.Ps)(_templateObject(), name);
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/toast.hook.tsx + 4 modules
var toast_hook = __webpack_require__(11263);
// EXTERNAL MODULE: ./src/components/Modal.tsx
var Modal = __webpack_require__(43354);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
// EXTERNAL MODULE: ./src/hooks/useOrderState.tsx
var useOrderState = __webpack_require__(778);
// EXTERNAL MODULE: ./src/hooks/useMekiState.tsx + 1 modules
var useMekiState = __webpack_require__(48231);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/screens/home/components/AssistantButton.tsx
/*
 * File: AssistantButton.tsx
 * Project: meki
 * File Created: Wednesday, 29th December 2021 4:39:13 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Thursday, 24th November 2022 4:10:32 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
















var FloatingAssistantButton = dynamic_default()(function() {
    var promise = Promise.all(/* import() */[__webpack_require__.e(3780), __webpack_require__.e(4645)]).then(__webpack_require__.bind(__webpack_require__, 4645)).then(function(mod) {
        return mod.FloatingAssistantButton;
    });
    return promise;
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4645)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return null;
    }
});
var AssistantCreateNewOrderFab = (0,styled/* default */.Z)(Fab/* default */.Z)({
    position: "fixed",
    right: 15,
    bottom: 70
});
function AssistantButton() {
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var toasts = (0,toast_hook/* useToast */.p)();
    // App state
    var setOrderUuid = (0,useOrderState/* useOrderState */.h)().setOrderUuid;
    var setUserEmail = (0,useMekiState/* useMekiState */.c)().setUserEmail;
    // Local state
    var ref = (0,react.useState)(false), newOrderModal = ref[0], setNewOrderModal = ref[1];
    // Other vars
    var isAssistant = userCan("MANAGE_USER");
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CreateOrderMutation("assistantCreateOrderHome")), 2), mutate = ref1[0], loading = ref1[1].loading;
    if (!isAssistant) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingAssistantButton, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AssistantCreateNewOrderFab, {
                color: "primary",
                variant: "extended",
                onClick: function() {
                    return setNewOrderModal(true);
                },
                disabled: loading,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {}),
                    "Cotizaci\xf3n"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* AlertModal */.VF, {
                title: "Nueva cotizaci\xf3n ⚠️",
                content: "Se crear\xe1 una nueva cotizaci\xf3n vacia y no podr\xe1s acceder a la anterior",
                open: newOrderModal,
                setOpen: setNewOrderModal,
                onClose: function() {
                    return setNewOrderModal(false);
                },
                actions: [
                    {
                        text: "CANCELAR",
                        onActionClick: function() {
                            return setNewOrderModal(false);
                        }
                    },
                    {
                        text: "confirmar",
                        onActionClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            var ref, _data, order;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        setNewOrderModal(false);
                                        setUserEmail("");
                                        return [
                                            4,
                                            mutate()
                                        ];
                                    case 1:
                                        ref = _state.sent(), _data = ref.data, order = _data.createOrder;
                                        utils/* Console.log */.Mn.log({
                                            msg: "[Home] change order uuid",
                                            orderUuid: order.uuid
                                        });
                                        setOrderUuid(order.uuid);
                                        toasts.showToast({
                                            message: "Inicio de nueva cotizaci\xf3n",
                                            type: "success"
                                        });
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        variant: "contained"
                    }, 
                ]
            })
        ]
    });
}


/***/ }),

/***/ 81879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ ReferralBanner; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70917);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13264);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71096);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8881);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26993);
/* harmony import */ var _hooks_usePermissions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18782);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    0% {\n      opacity: 1;\n      transform: scale(1);\n    }\n    50% {\n      transform: scale(1.1);\n      opacity: 0.5;\n      }\n    100% {\n      transform: scale(1);\n      opacity: 1;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var growOnClick = (0,_mui_system__WEBPACK_IMPORTED_MODULE_8__/* .keyframes */ .F4)(_templateObject());
var ImageContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "clicked";
    }
})(function(param) {
    var clicked = param.clicked;
    return {
        position: "relative",
        width: "100%",
        height: "100px",
        maxHeight: "100px",
        marginBottom: "16px",
        cursor: "pointer",
        animation: clicked ? "".concat(growOnClick, " 0.25s") : undefined
    };
});
var BannerContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
});
var ShareTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        fontFamily: "Poppins",
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0.15px",
        color: "#15365F",
        textAlign: "center"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(990), {
        fontSize: "28px",
        lineHeight: "42px"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(608), {
        fontSize: "24px",
        lineHeight: "36px"
    }), _obj;
});
var MoreInfoButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        fontFamily: "Poppins",
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "14px",
        lineHeight: "21px",
        letterSpacing: "0.15px",
        textAlign: "center",
        textTransform: "none",
        textDecorationLine: "underline",
        color: "#0A7ABE"
    }, theme.breakpoints.up(990), {
        fontSize: "16px",
        lineHeight: "24px"
    });
});
var TextDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        minWidth: "259px"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(990), {
        minWidth: "449px"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(608), {
        minWidth: "386px"
    }), _obj;
});
var handleImageByWidth = function(width) {
    if (width >= 990) {
        return "/assets/images/banners/referralBannerBig.webp";
    }
    if (width >= 608) {
        return "/assets/images/banners/referralBannerMedium.webp";
    }
    return "/assets/images/banners/referralBannerSmall.webp";
};
function ReferralBanner() {
    var width = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_4__/* .useWindowSize */ .i)().width;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), clicked = ref[0], setClicked = ref[1];
    var userCan = (0,_hooks_usePermissions__WEBPACK_IMPORTED_MODULE_7__/* .usePermissions */ .T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    if (isLocalVendor) {
        return null;
    }
    var handleClick = function() {
        setClicked(true);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
        href: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .getRoute */ .Bv)("referral"),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BannerContainer, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ImageContainer, {
                onClick: handleClick,
                clicked: clicked,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                        src: handleImageByWidth(width),
                        alt: "Referral Banner",
                        layout: "fill",
                        priority: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TextDiv, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ShareTypography, {
                                children: "\xa1Comparte y gana descuentos!"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MoreInfoButton, {
                                children: "M\xe1s informaci\xf3n"
                            })
                        ]
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 87044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DP": function() { return /* reexport */ CategoryProducts; },
  "si": function() { return /* reexport */ HelloLoggedOut; }
});

// UNUSED EXPORTS: BioequivalenceDialog, HomeCategoriesSlider, ReferralBanner

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(71641);
// EXTERNAL MODULE: ./src/components/Products/index.tsx + 1 modules
var Products = __webpack_require__(71728);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(68921);
;// CONCATENATED MODULE: ./src/queries/category/getCategoryOnly.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ",
        " ($params: GetCategoryParams!) {\n  category(params: $params ) {\n    name\n    slug\n    id\n    products {\n        id\n        uuid\n        slug\n        name\n        price\n        discount {\n          price\n          type\n          stockRestriction\n          dateRestriction\n          listPrice\n        }\n        concentration\n        unit\n        format\n        quantity\n        package\n        composition\n        display\n        containerQuantity\n        container\n        availability {\n          status\n          discountStock\n          stock\n        }\n        imagesUrl\n        activePrinciple\n        laboratory\n        isCheapestActivePrinciple\n    }\n  }\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getCategoryOnly = function(name) {
    return (0,lib/* gql */.Ps)(_templateObject(), name);
};

// EXTERNAL MODULE: ./src/hooks/useWindowSize.ts
var hooks_useWindowSize = __webpack_require__(71096);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var hooks_useSegment = __webpack_require__(59945);
;// CONCATENATED MODULE: ./src/screens/home/components/CategoryProducts.tsx











var ListContainer = (0,styled/* default */.Z)("div")({
    display: "flex"
});
var TextLink = (0,styled/* default */.Z)("a")(function() {
    return {
        color: "#0A7ABE",
        textDecoration: "none"
    };
});
function CategoryProducts(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var width = (0,hooks_useWindowSize/* useWindowSize */.i)().width;
    var slug = props.slug, productLocation = props.productLocation, categoryLocation = props.categoryLocation;
    var track = (0,hooks_useSegment/* useSegment */.K)().track;
    var data = (0,useQuery/* useQuery */.a)(getCategoryOnly("categoryBestSelling"), {
        variables: {
            params: {
                slug: slug
            }
        },
        fetchPolicy: "cache-and-network"
    }).data;
    var handleTitle = function(width, name) {
        if (width < 768) {
            return name;
        }
        return "Lo m\xe1s visto en ".concat(name);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (data === null || data === void 0 ? void 0 : (ref = data.category) === null || ref === void 0 ? void 0 : (ref1 = ref.products) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Products/* Products.Carousel */.Q.Carousel, {
                data: data === null || data === void 0 ? void 0 : (ref2 = data.category) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.products) === null || ref3 === void 0 ? void 0 : ref3.map(function(product) {
                    return {
                        product: product
                    };
                }),
                totalCount: data === null || data === void 0 ? void 0 : (ref4 = data.category) === null || ref4 === void 0 ? void 0 : ref4.products.length,
                loading: false,
                title: handleTitle(width, data === null || data === void 0 ? void 0 : (ref5 = data.category) === null || ref5 === void 0 ? void 0 : ref5.name),
                action: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,utils/* getRoute */.Bv)("category", {
                    categorySlug: slug,
                    page: "1"
                }).toLink()), {
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink, {
                        onClick: function() {
                            var ref;
                            void track("category", {
                                category: data === null || data === void 0 ? void 0 : (ref = data.category) === null || ref === void 0 ? void 0 : ref.name,
                                location: categoryLocation
                            });
                        },
                        children: "Ver todo"
                    })
                })),
                location: productLocation
            })
        })
    });
}

// EXTERNAL MODULE: ./src/screens/home/components/ReferralBanner.tsx
var ReferralBanner = __webpack_require__(81879);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ImageList/ImageList.js + 1 modules
var ImageList = __webpack_require__(30530);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ImageListItem/ImageListItem.js + 1 modules
var ImageListItem = __webpack_require__(80412);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Skeletons.tsx
var Skeletons = __webpack_require__(57758);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./src/screens/home/components/categoriesSlider.tsx
/*
 * File: categoriesSlider.tsx
 * Project: meki
 * File Created: Monday, 6th December 2021 3:54:51 pm
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Friday, 3rd November 2023 4:01:45 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 




function categoriesSlider_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    0% {\n      transform: scale(1);\n    }\n    50% {\n      transform: scale(1.1);\n    }\n    100% {\n      transform: scale(1);\n    }\n"
    ]);
    categoriesSlider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var CategoryIconDiv = (0,styled/* default */.Z)("div")({
    position: "relative",
    display: "flex",
    justifyContent: "center",
    height: "113px",
    width: "128px"
});
var RootDiv = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        width: "100%"
    };
});
var CategoriesSliderImageList = (0,styled/* default */.Z)(ImageList/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        width: "100%",
        "&::-webkit-scrollbar": {
            display: "none"
        },
        msOverflowStyle: "none" /* IE and Edge */ ,
        scrollbarWidth: "none" /* Firefox */ ,
        scrollBehavior: "smooth",
        paddingTop: 16,
        paddingLeft: "8px",
        paddingBottom: 16
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(540), {
        paddingTop: 16
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up(1200), {
        justifyContent: "center"
    }), _obj;
});
var growOnClick = (0,emotion_react_browser_esm/* keyframes */.F4)(categoriesSlider_templateObject());
var SlideItemImageListItemContainer = (0,styled/* default */.Z)(ImageListItem/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "clicked" && prop !== "version";
    }
})(function(props) {
    return (0,_define_property/* default */.Z)({
        height: "auto",
        width: "200px",
        textAlign: "center",
        cursor: "pointer",
        padding: "0px 0px",
        margin: "0 2vw 0 2vw",
        boxSizing: "border-box",
        flexShrink: 0,
        animation: props.clicked ? "".concat(growOnClick, " 0.25s") : undefined,
        border: "none",
        borderRadius: "8px"
    }, props.theme.breakpoints.down(768), {
        width: "149px",
        height: "131px !important"
    });
});
var SlideItemImageListItem = function(props) {
    var ref = useState(false), clicked = ref[0], setClicked = ref[1];
    var handleClick = function(e) {
        var ref;
        (ref = props.onClick) === null || ref === void 0 ? void 0 : ref.call(props, e);
        setClicked(true);
    };
    return /*#__PURE__*/ _jsx(SlideItemImageListItemContainer, _object_spread_props(_object_spread({}, props), {
        onClick: handleClick,
        clicked: clicked,
        onAnimationEnd: function() {
            return setClicked(false);
        }
    }));
};
var CategoryItemDiv = (0,styled/* default */.Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "version";
    }
})(function(param) {
    var version = param.version;
    return {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
        position: "relative",
        padding: "5px 20px",
        backgroundColor: "#FFFFFF",
        borderRadius: "6px",
        boxShadow: version == "version1" ? "0px 0px 4px 0px #00000040" : "none",
        zIndex: 1
    };
});
var TitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        marginTop: 12,
        hyphens: "manual",
        fontSize: "15px",
        fontWeight: 500,
        lineHeight: "20.5px",
        letterSpacing: "0.0928571px"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up(500), {
        width: 115,
        fontWeight: 600,
        lineHeight: "20px"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up(768), {
        width: 125,
        fontWeight: 600,
        lineHeight: "24px"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up(1024), {
        fontSize: 19,
        width: 150,
        fontWeight: 600,
        lineHeight: "28px"
    }), _obj;
});
var cartegoriesOrderBy = (/* unused pure expression or super */ null && ([
    "medicamentos",
    "cuidado-personal",
    "nutricion",
    "belleza",
    "accesorios-y-dispositivos", 
]));
function SliderItemIcon(param) {
    var slug = param.slug;
    var ref = useState(1), quality = ref[0], setQuality = ref[1];
    var completeLoaded = useCallback(function() {
        setQuality(100);
    }, []);
    if (slug === "medicamentos") {
        return /*#__PURE__*/ _jsx(CategoryIconDiv, {
            children: /*#__PURE__*/ _jsx(Image, {
                layout: "fill",
                objectFit: "contain",
                quality: quality,
                onLoadingComplete: completeLoaded,
                src: "/assets/images/categories/bottle_with_pills.webp",
                alt: "Medicamentos",
                sizes: "128px"
            })
        });
    }
    if (slug === "cuidado-personal") {
        return /*#__PURE__*/ _jsx(CategoryIconDiv, {
            children: /*#__PURE__*/ _jsx(Image, {
                layout: "fill",
                objectFit: "contain",
                quality: quality,
                onLoadingComplete: completeLoaded,
                src: "/assets/images/categories/tooth_brush.webp",
                alt: "Cuidado personal",
                sizes: "128px"
            })
        });
    }
    if (slug === "nutricion") {
        return /*#__PURE__*/ _jsx(CategoryIconDiv, {
            children: /*#__PURE__*/ _jsx(Image, {
                layout: "fill",
                objectFit: "contain",
                quality: quality,
                onLoadingComplete: completeLoaded,
                src: "/assets/images/categories/vitamins.webp",
                alt: "Nutrici\xf3n",
                sizes: "128px"
            })
        });
    }
    if (slug === "belleza") {
        return /*#__PURE__*/ _jsx(CategoryIconDiv, {
            children: /*#__PURE__*/ _jsx(Image, {
                layout: "fill",
                objectFit: "contain",
                quality: quality,
                onLoadingComplete: completeLoaded,
                src: "/assets/images/categories/bottle_with_pipette.webp",
                alt: "Belleza",
                sizes: "128px"
            })
        });
    }
    if (slug === "accesorios-y-dispositivos") {
        return /*#__PURE__*/ _jsx(CategoryIconDiv, {
            children: /*#__PURE__*/ _jsx(Image, {
                layout: "fill",
                objectFit: "contain",
                quality: quality,
                onLoadingComplete: completeLoaded,
                src: "/assets/images/categories/thermometer.webp",
                alt: "Accesorios y dispositivos",
                sizes: "128px"
            })
        });
    }
}
function HomeCategoriesSlider(param) {
    var categories = param.categories, version = param.version, location = param.location;
    // Hooks init
    var router = useRouter();
    var width = useWindowSize().width;
    var track = useSegment().track;
    var sortCategoies = useMemo(function() {
        if (categories) {
            return _to_consumable_array(categories).sort(function(a, b) {
                return cartegoriesOrderBy.indexOf(a.slug) - cartegoriesOrderBy.indexOf(b.slug);
            });
        }
        return categories;
    }, [
        categories
    ]);
    var cols = useMemo(function() {
        if (sortCategoies) {
            return Math.min(getColsAmount({
                itemWidth: 128,
                width: Math.min(width, 900)
            }), sortCategoies.length);
        }
        return 0;
    }, [
        sortCategoies,
        width
    ]);
    var refFirst = useRef(null);
    var refLast = useRef(null);
    var sliderRef = useRef(null);
    var formatTitle = function(text) {
        var title = text.split(" ");
        var formattedWords = title.map(function(word, index) {
            if (word === "y" && index !== 0) {
                return word;
            } else {
                return word.charAt(0).toUpperCase() + word.slice(1);
            }
        });
        return formattedWords.join(" ");
        return title;
    };
    return /*#__PURE__*/ _jsx(RootDiv, {
        children: sortCategoies.length > 0 ? /*#__PURE__*/ _jsx(CategoriesSliderImageList, {
            cols: cols,
            gap: 0,
            ref: sliderRef,
            children: sortCategoies.map(function(category, i) {
                return /*#__PURE__*/ _jsx(SlideItemImageListItem, {
                    onClick: function() {
                        void router.push(getRoute("subCategories", {
                            categorySlug: category.slug
                        }));
                        void track("category", {
                            category: category.name,
                            location: location
                        });
                    },
                    ref: i == sortCategoies.length - 1 ? refLast : i == 0 ? refFirst : null,
                    children: /*#__PURE__*/ _jsxs(CategoryItemDiv, {
                        version: version,
                        children: [
                            /*#__PURE__*/ _jsx(SliderItemIcon, {
                                slug: category.slug
                            }),
                            /*#__PURE__*/ _jsx(TitleTypography, {
                                variant: "subtitle2",
                                children: formatTitle(category.name)
                            })
                        ]
                    })
                }, category.slug + i.toString());
            })
        }) : /*#__PURE__*/ _jsx(CategoriesSliderSkeleton, {})
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styles_styled = __webpack_require__(81719);
;// CONCATENATED MODULE: ./src/screens/home/components/bioequivalenceDialog.styles.tsx


var bioequivalenceDialog_styles_InfoDialog = (0,styles_styled/* default */.ZP)("dialog")({
    display: "flex",
    flexDirection: "column",
    position: "fixed",
    top: "25%",
    left: "0%",
    height: "382px",
    width: "328px",
    border: "1px solid #EAEAEA",
    borderRadius: "10px",
    zIndex: 1000
});
var bioequivalenceDialog_styles_DialogTitleTypography = (0,styles_styled/* default */.ZP)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontSize: "17px",
    fontWeight: 600,
    lineHeight: "26px",
    letterSpacing: "-0.011em",
    textAlign: "center"
});
var bioequivalenceDialog_styles_DialogTextTypography = (0,styles_styled/* default */.ZP)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 300,
    lineHeight: "23px",
    letterSpacing: "-0.011em",
    textAlign: "center"
});
var bioequivalenceDialog_styles_ImageContainer = (0,styles_styled/* default */.ZP)("div")({
    position: "relative",
    height: "70px",
    width: "64px"
});
var bioequivalenceDialog_styles_IconContainer = (0,styles_styled/* default */.ZP)("div")({
    position: "relative",
    height: "14px",
    width: "14px",
    marginLeft: "90%"
});
var bioequivalenceDialog_styles_ContentDiv = (0,styles_styled/* default */.ZP)("div")({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "5px 3px 10px 3px"
});


;// CONCATENATED MODULE: ./src/screens/home/components/BioequivalenceDialog.tsx



function BioequivalenceDialog(props) {
    var handleCloseDialog = props.handleCloseDialog;
    return /*#__PURE__*/ _jsxs(InfoDialog, {
        children: [
            /*#__PURE__*/ _jsx(IconContainer, {
                children: /*#__PURE__*/ _jsx(Image, {
                    layout: "fill",
                    src: "assets/images/home/closeicon.webp",
                    alt: "closeIcon",
                    objectFit: "contain",
                    onClick: handleCloseDialog
                })
            }),
            /*#__PURE__*/ _jsxs(ContentDiv, {
                children: [
                    /*#__PURE__*/ _jsx(ImageContainer, {
                        children: /*#__PURE__*/ _jsx(Image, {
                            layout: "fill",
                            src: "assets/images/ISPLogo2.webp",
                            alt: "bioequivalence",
                            objectFit: "contain"
                        })
                    }),
                    /*#__PURE__*/ _jsx(DialogTitleTypography, {
                        children: "Bioequivalencia"
                    }),
                    /*#__PURE__*/ _jsx(DialogTextTypography, {
                        children: "Un medicamento equivalente terap\xe9utico es aquel que cumple con: tener el registro sanitario actualizado, tener el proceso de manufactura validado y haber presentado un estudio farmacocin\xe9tico de biodisponibilidad comparativa, por lo tanto, posee la misma eficacia y seguridad que el producto comparador."
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/utils/routes.ts
var routes = __webpack_require__(68139);
// EXTERNAL MODULE: ./src/hooks/useModalRouter.ts
var useModalRouter = __webpack_require__(9006);
;// CONCATENATED MODULE: ./src/screens/home/components/helloLoggedOut.styles.tsx


var DivContainer = (0,styles_styled/* default */.ZP)("div")({
    display: "flex",
    flexDirection: "column",
    position: "relative",
    backgroundColor: "#FFFFFF",
    border: "1px solid #EAEAEA",
    borderRadius: "10px",
    height: "fit-content",
    width: "336px"
});
var TextContainer = (0,styles_styled/* default */.ZP)("div")({
    padding: "12px 15px"
});
var HelloTypography = (0,styles_styled/* default */.ZP)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontSize: "36px",
    lineHeight: "54px",
    letterSpacing: "0.15px",
    fontWeight: 500,
    color: "#414046"
});
var SubtitleTypography = (0,styles_styled/* default */.ZP)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.15px",
    fontWeight: 500
});
var DrawerMenuDivider = (0,styles_styled/* default */.ZP)("hr")({
    class: "solid",
    width: "99.9%",
    border: "0.5px solid #EAEAEA",
    margin: "0px"
});
var LoginButton = (0,styles_styled/* default */.ZP)("button")({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.16px",
    color: "#0A7ABE",
    textTransform: "none",
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer",
    padding: "10px",
    margin: "0px",
    justifyContent: "center",
    alignItems: "center"
});


;// CONCATENATED MODULE: ./src/screens/home/components/HelloLoggedOut.tsx





function HelloLoggedOut() {
    var modalRouter = (0,useModalRouter/* useModalRouter */.r)();
    var handleSignIn = function() {
        void modalRouter.push((0,routes/* getRoute */.Bv)("signin"));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DivContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelloTypography, {
                        children: "\xa1Hola!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubtitleTypography, {
                        children: "Ingresa a tu cuenta para ver tus pedidos, boletas, \xfaltimas compras, etc"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerMenuDivider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginButton, {
                onClick: handleSignIn,
                children: "Iniciar sesi\xf3n"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/screens/home/components/index.ts







/***/ }),

/***/ 9762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ CategoriesCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Card/Card.js + 1 modules
var Card = __webpack_require__(49837);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
;// CONCATENATED MODULE: ./src/screens/home/landing/HeroSection/style/categoryCard.style.tsx



var CategoriesCardContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme, logIn = param.logIn;
    var _obj;
    return _obj = {
        zIndex: 10,
        display: "flex",
        flexDirection: "row",
        gap: 30,
        overflowX: "auto",
        justifyContent: logIn ? "left" : "center",
        padding: logIn ? 32 : 10,
        paddingLeft: logIn ? "4%" : 0
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        padding: logIn ? "20px 20px" : "0px 20px",
        gap: 10,
        justifyContent: "left"
    }), (0,_define_property/* default */.Z)(_obj, "scrollbarWidth", "none"), (0,_define_property/* default */.Z)(_obj, "-ms-overflow-style", "none"), (0,_define_property/* default */.Z)(_obj, "&::-webkit-scrollbar", {
        display: "none"
    }), _obj;
});
var CategoryCardContainer = (0,styled/* default */.Z)(Card/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        backgroundColor: "#FFFFFF",
        width: 200,
        height: 176,
        padding: 10,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        borderRadius: 8,
        flex: "0 0 auto",
        cursor: "pointer",
        boxShadow: "0px 0px 12px rgba(0,0,0,0.3)",
        marginTop: "4px"
    }, theme.breakpoints.down("md"), {
        width: "148px",
        height: "140px",
        padding: 4
    });
});
var CategoryCardTitle = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontSize: 18,
        fontWeight: 600,
        color: "#414046",
        textAlign: "center",
        fontFamily: "Poppins",
        whiteSpace: "pre-wrap",
        padding: "0px 10px"
    }, theme.breakpoints.down("md"), {
        fontSize: 14,
        maxWidth: 120
    });
});


// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/screens/home/landing/HeroSection/categoriesCard.tsx






var categories = [
    {
        name: "Medicamentos",
        image: "/assets/images/newLanding/CategoriesMenu/Medicamentos.svg",
        slug: "medicamentos"
    },
    {
        name: "Cuidado personal",
        image: "/assets/images/newLanding/CategoriesMenu/CuidadoPersonal.svg",
        slug: "cuidado-personal"
    },
    {
        name: "Belleza",
        image: "/assets/images/newLanding/CategoriesMenu/Belleza.svg",
        slug: "belleza"
    },
    {
        name: "Vitaminas y suplementos",
        image: "/assets/images/newLanding/CategoriesMenu/VitySupl.svg",
        slug: "vitaminas-y-suplementos"
    },
    {
        name: "Mascotas",
        image: "/assets/images/newLanding/CategoriesMenu/Mascotas.svg",
        slug: "veterinaria"
    }, 
];
var CategoriesCard = function() {
    var router = (0,next_router.useRouter)();
    var currentLocation = (0,react.useMemo)(function() {
        return router.asPath.includes("inicio");
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesCardContainer, {
        logIn: currentLocation,
        children: categories.map(function(category) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryCardContainer, {
                onClick: function() {
                    void router.push((0,utils/* getRoute */.Bv)("subCategories", {
                        categorySlug: category.slug
                    }));
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: category.image,
                        alt: category.name,
                        width: 78,
                        height: 78
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryCardTitle, {
                        children: category.name
                    })
                ]
            }, category.name);
        })
    });
};


/***/ }),

/***/ 49830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YO": function() { return /* binding */ HomeRootDiv; },
/* harmony export */   "ZD": function() { return /* binding */ CarouselsContainer; },
/* harmony export */   "t4": function() { return /* binding */ SidePadding; }
/* harmony export */ });
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13264);

var HomeRootDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    paddingTop: "12px",
    backgroundColor: "#F5F5F5",
    paddingBottom: "20px"
});
var SidePadding = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    paddingLeft: "4%",
    paddingRight: "4%",
    backgroundColor: "#F5F5F5"
});
var CarouselsContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    "&:last-child": {
        marginBottom: "-20px"
    }
});



/***/ })

}]);